import i18n from 'i18next';
import moment from 'moment';
import '../i18n/config';

// Display the date of an app Version ('createdAt' attribute in DB) with hour + am/pm and today/yesterday
export function prettyDate(date: Date | string, withHours: boolean): string {
    const yesterdaysDate = new Date().setDate(new Date().getDate() - 1);
    const today = moment(new Date()).format('D MMM YYYY');
    const yesterday = moment(yesterdaysDate).format('D MMM YYYY');
    const dbDate = moment(date).format('D MMM YYYY');

    let dateToReturn;
    if (date === '-') {
        dateToReturn = date;
    } else if (dbDate === today) {
        dateToReturn = `${i18n.t('date.today')}`;
    } else if (dbDate === yesterday) {
        dateToReturn = `${i18n.t('date.yesterday')}`;
    } else {
        dateToReturn = `${dbDate}`;
    }

    if (withHours) {
        const hmmaDate = moment(date).format('h:mm a');
        dateToReturn += ` ${i18n.t('date.at')} ${hmmaDate}`;
    }
    return dateToReturn;
}

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T{0,1}\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

const isIsoDateString = (value: any): boolean => {
    return value && typeof value === 'string' && isoDateFormat.test(value);
};

export const handleDates = (body: any) => {
    if (body === null || body === undefined || typeof body !== 'object') return body;

    for (const key of Object.keys(body)) {
        const value = body[key];
        if (isIsoDateString(value)) {
            body[key] = new Date(value);
        } else if (typeof value === 'object') {
            handleDates(value);
        }
    }

    return body;
};
